<template>
    <div class="page-header" :class="ecnu?'pt-3':''" >
        <div class="page-container" style="position: relative;width: 100%">
            <div class="d-none d-md-block" style="position: absolute;right: 10px;top: -10px;">
                <digital-clock :ecnu="ecnu"></digital-clock>
            </div>
            <div class="logo justify-content-sm-start justify-content-center">
                <img class="" :src="logo" alt="university-logo">
                <div class="title d-none d-sm-block pt-0 ml-5 " v-if="ecnu">
                    <img src="~@/assets/images/sigin-ecnu-logo.png" alt=""/>
                </div>
                <div class="title d-none " v-else>{{preset.app.name ||
                    '视频会议系统'}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DigitalClock from "./digital-clock";
    import {mapState} from "vuex";

    export default {
        name: "page-header",
        components: {DigitalClock},
        data() {
            return {}
        },
        props: {
            ecnu: {
                type: Boolean, default() {
                    return false;
                }
            },
            ulogo:{
                type: String, default() {
                    return null;
                }
            },
        },
        computed: {
            ...mapState(['user', 'preset']),
            logo() {
                if (this.user.ulogo) return this.user.ulogo;
                if (this.ulogo) return this.ulogo;
                return this.$organization.prefix + '/assets/' + this.$organization.org + '/images/u-logo.png';
            },
        }
    }
</script>

<style lang="scss">
    .page-header {
        height: 110px;
        padding: 10px 0;

        .logo {
            display: flex;

            img {
                max-height: 70px;
                max-width: 100%;
            }

            .title {
                padding-top: 4px;
                padding-left: 20px;
                font-size: 30px;
                font-weight: 400;
                color: #607d8b;

                &.ecnu {
                    font-size: 20px;
                    font-weight: 400;
                    color: #222222;
                }
            }

        }

    }
</style>
